// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1xohl","right":"Footer_right__3Bq8V","buttons":"Footer_buttons__q99QZ"};